import styled from 'styled-components';

import { media } from '~src/styles/media-templates';

import { IconFieldWrapper } from './iconField.sc';

export const ButtonSection = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 30px;
  margin: 15px -30px -30px -30px;
  > button {
    margin-left: 10px;
  }
`;

export const CapitalizeFirst = styled.span`
  &::first-letter {
    text-transform: capitalize;
  }
`;

const Section = styled.div``;

export const Visibility = styled.div`
  display: flex;
  flex-direction: column;
  > div {
    &:nth-child(2) {
      margin-bottom: 10px;
      height: 100%;
      width: 100%;
    }
  }
`;

export const PrimarySection = styled(Section)`
  width: 66.6%;
  ${media.tablet`
    width: 100%;
  `}
`;

export const SecondarySection = styled(Section)`
  width: 33.3%;
  margin-left: 60px;
  display: flex;
  flex-direction: column;
  ${media.tablet`
    width: 100%;
    margin-left: 0px;
  `}
`;

export const SubInfoContainer = styled.div`
  margin-top: 115px;
  ${IconFieldWrapper} {
    &:not(:first-child) {
      margin-top: 15px;
    }
  }
`;

export const InlineSubInfoContainer = styled.div`
  ${IconFieldWrapper} {
    &:not(:first-child) {
      margin-top: 15px;
    }
  }
`;

export const OwnersSection = styled.div`
  margin-top: 45px;
`;

export const Repetition = styled.div`
  display: flex;
  align-items: center;
  > div:first-child {
    flex: 1;
  }
  > div:nth-child(2) {
    margin-left: 5px;
    cursor: pointer;
  }
`;

export const InfoContainer = styled.div<{ $editMode?: boolean }>`
  width: 100%;
  > div {
    margin-bottom: ${({ $editMode }) => ($editMode ? '15px' : '45px')};
  }
`;

export const LabelsWrapper = styled.div`
  margin-top: 45px;
`;

export const UpdateButtonContainer = styled.div`
  display: none;
  position: absolute;
  padding: 30px;
  right: 0;
  top: calc(50% - 52px);
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 9%,
    rgba(255, 255, 255, 1) 100%
  );
`;

export const ElementWrapper = styled.div<{ $selectable?: boolean }>`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  min-height: 105px; /* to completely cover the 'delete' button inside */
  padding: 15px;
  border-radius: 5px;
  background: ${({ theme }) => theme.white.a10};
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.03);
  color: ${({ theme }) => theme.baseBlue.a10};
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  align-items: stretch;
  transform: perspective(1px) translateZ(0);
  backface-visibility: hidden;
  cursor: ${({ $selectable }) => ($selectable ? 'pointer' : 'normal')};
  &:hover {
    ${UpdateButtonContainer} {
      display: flex;
    }
  }
  &:hover,
  &.selected {
    box-shadow: ${({ $selectable, theme }) =>
      $selectable ? `0 8px 16px 0 ${theme.black.a2}` : '0 4px 14px 0 rgba(0, 0, 0, 0.03)'};
    z-index: 1;
    transform: ${({ $selectable }) =>
      $selectable ? 'scale(1.01, 1.01) perspective(1px) translateZ(0)' : 'none'};
  }
  > span {
    line-height: 25px;
  }
`;
export const Title = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  height: 60px;
  span {
    margin-right: 10px;
    color: ${({ theme, $active }) => ($active ? theme.baseBlue.a10 : theme.baseBlue.a6)};
    cursor: ${({ $active }) => ($active ? 'initial' : 'pointer')};
  }
`;
export const KeyResultsList = styled.ul``;
export const SubObjectivesList = styled.ul``;

export const LoadingWrapper = styled.div`
  margin-top: 80px;
`;

export const Forbidden = styled.div`
  cursor: not-allowed;
  width: 100%;
`;

export const WeightingContainer = styled.span`
  margin-left: auto;
  font-size: small;
  color: ${({ theme }) => theme.baseBlue.a6};
`;
export const SubSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RightSection = styled.div`
  align-items: center;
`;
